export enum actionType {
  ADD = "ADD",
  DEDUCT = "DEDUCT",
  EDIT = "EDIT",
  REFUND = "REFUND",
}
